import { createFileRoute, redirect } from "@tanstack/react-router";
import { ControlCodes, queries } from "@theprelude/core";
import { setPageTitle } from "@/components/app-shell/app-shell";

import { authorizeFeatures } from "@/lib/authorize-feature";

export const Route = createFileRoute("/_app/threat-intel/")({
  beforeLoad: async ({ context }) => {
    setPageTitle("Threat Intel");
    const authConfig = await context.auth.getAuthConfig();
    const account = await context.queryClient.ensureQueryData(
      queries.iam.getAccount(authConfig),
    );

    await authorizeFeatures(context, ["detect", "threat_intel"]);

    const hasCrowdstrike = account.controls.some(
      (c) => c.id === ControlCodes.CROWDSTRIKE,
    );

    throw redirect({
      to: hasCrowdstrike
        ? "/threat-intel/import/feed"
        : "/threat-intel/import/upload",
      replace: true,
    });
  },
});
